/* Background-video sound.

   Goal: the hero video plays WITH audio, and the mute button stays available
   so visitors can turn it off.

   Browsers do not allow unmuted autoplay unless the visitor has enough prior
   engagement with the site, so this does three things in order:
     1. try to play unmuted straight away (works for returning visitors);
     2. if the browser blocks it, keep playing muted and turn sound on at the
        visitor's first real gesture - that unlocks audio;
     3. once the visitor mutes it by hand, leave it alone for the rest of the
        page view, and never turn sound on for a video scrolled out of view.

   The mute choice is deliberately NOT persisted across page loads: every load
   starts with sound, and nothing can carry a stale "stay muted" flag forward.

   The <video> is cloned into the DOM by the theme after load, so it is looked
   up lazily and the initial button state is synced by a short poll. */
(function () {
  if (window.__t4sBgVidSound) return;   // only wire up once per page
  window.__t4sBgVidSound = true;

  var userMuted = false;                // set only by a real click on the button

  function videoFor(btn) {
    var host = btn.closest('.t4s-hero-video, .t4s_bg_video, section, .shopify-section') || document;
    return host.querySelector('video.t4s_bg_vid_html5, video');
  }
  function videos() {
    return Array.prototype.slice.call(document.querySelectorAll('video.t4s_bg_vid_html5'));
  }
  function inView(v) {
    var r = v.getBoundingClientRect();
    return r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
  }

  function paint(btn, muted) {
    btn.setAttribute('aria-pressed', muted ? 'false' : 'true');
    btn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
    btn.classList.toggle('is-muted', muted);
    btn.classList.toggle('is-unmuted', !muted);
  }
  function syncAll() {
    document.querySelectorAll('[data-bgvid-sound]').forEach(function (btn) {
      var v = videoFor(btn);
      if (v) paint(btn, v.muted !== false);
    });
  }

  /* Turn sound on. Resolves true if the browser let it keep playing. */
  function soundOn(v) {
    v.muted = false;
    v.volume = 1;
    var p = v.play();
    var started = (p && p.then) ? p : Promise.resolve();
    return started.then(function () {
      // Chrome may accept play() and then pause an unmuted autoplay, so verify.
      return new Promise(function (res) {
        setTimeout(function () { res(!v.paused && !v.muted); }, 250);
      });
    }).catch(function () { return false; });
  }

  function fallBackToMuted(v) {
    v.muted = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
    syncAll();
  }

  /* Turn sound on at the visitor's first real gesture.

     Only events that grant user activation are worth listening for. Scrolling
     does NOT: verified on the live site that `navigator.userActivation
     .hasBeenActive` is still false after a real wheel scroll, so unmuting from
     a scroll always fails. Chrome grants activation on pointerdown/pointerup/
     touchend/keydown/click, so those are the triggers.

     The listeners stay attached until sound is ACTUALLY on. An earlier version
     detached them on the first attempt, so one failed try left the hero mute
     for the rest of the visit. */
  var armed = false;
  function armGesture() {
    if (armed) return;
    armed = true;
    var evts = ['pointerdown', 'pointerup', 'touchend', 'keydown', 'click'];
    function stop() {
      evts.forEach(function (ev) { document.removeEventListener(ev, go, true); });
    }
    function go(e) {
      // A click on the mute button is that button's business, not ours.
      if (e && e.target && e.target.closest && e.target.closest('[data-bgvid-sound]')) return;
      if (userMuted) { stop(); return; }
      videos().forEach(function (v) {
        if (!inView(v)) return;            // don't blast audio further down the page
        soundOn(v).then(function (ok) {
          if (ok) { stop(); syncAll(); }   // done - only now do we stop listening
          else { fallBackToMuted(v); }     // keep listening for a gesture that works
        });
      });
    }
    evts.forEach(function (ev) { document.addEventListener(ev, go, true); });
  }

  function start(v) {
    if (v.__lrSoundTried) return;
    v.__lrSoundTried = true;
    soundOn(v).then(function (ok) {
      if (ok) { syncAll(); return; }
      fallBackToMuted(v);                  // blocked: keep it playing, silently
      armGesture();
    });
  }

  // Manual toggle. Only a real (trusted) click records a deliberate mute.
  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest('[data-bgvid-sound]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var v = videoFor(btn);
    if (!v) return;
    v.muted = !v.muted;
    if (e.isTrusted) userMuted = v.muted;
    if (!v.muted) {
      v.volume = 1;
      var p = v.play();                    // a click is a valid user gesture
      if (p && p.catch) p.catch(function () {});
    }
    paint(btn, v.muted);
  }, true);

  // The theme injects the video after load, so watch for it briefly.
  var tries = 0;
  var t = setInterval(function () {
    videos().forEach(start);
    syncAll();
    if (++tries > 20) clearInterval(t);
  }, 250);
  document.addEventListener('DOMContentLoaded', function () { videos().forEach(start); syncAll(); });
})();
